import React from 'react';
import { BarChart, Bar, XAxis, Tooltip } from 'recharts';
import styled from 'styled-components';
import StateDispatch from './contextInfo'

const TopCarsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
`
  const Title = styled.h2`
    font-size: 1.2em;
    font-weight: 400; 
    line-height: 100%;
    letter-spacing: 0.05em;
    padding-top: 0.32rem;
    color: #373D3F;
  `

function sortCars(a,b) {
  if (a.quantity < b.quantity) return 1
  else if (a.quantity > b.quantity) return -1
  else return 0
}


export default function TopCars () {
  const info = React.useContext(StateDispatch)

  const returnMap = [
    { name: '...', quantity: 12},
    { name: '...', quantity: 22},
    { name: '...', quantity: 12},
  ]

  const mapCars = {}
  for (let i = 0; i < info.length; i++) {
    let curClient = info[i]
    for (let j = 0; j < curClient.orders.length; j++) {
      let carCurOrder = curClient.orders[j].make
      if (!mapCars[carCurOrder]) mapCars[carCurOrder] = 1
      else mapCars[carCurOrder]++
      if (mapCars[carCurOrder] > returnMap[2].quantity && carCurOrder !== returnMap[2].name && carCurOrder !== returnMap[1].name && carCurOrder !== returnMap[0].name) {
        returnMap[2] = { name: carCurOrder, quantity: mapCars[carCurOrder]}
        returnMap.sort(sortCars)
      }
    }
  }

  return (
    <TopCarsWrapper>
      <Title>Top Cars</Title>
        <BarChart
          width={290}
          height={270}
          data={returnMap}
        >
          <XAxis dataKey="name" />
     
          <Tooltip />
          <Bar dataKey="quantity" fill="#4285F4" />
        </BarChart>
    </TopCarsWrapper>
  );
}

